import script from "./CheckInDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckInDetail.vue?vue&type=script&setup=true&lang=js"

import "./CheckInDetail.vue?vue&type=style&index=0&id=2f3de1f2&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3de1f2"]])

export default __exports__